const decodeBase64Url = (base64Url) => {
  if (!base64Url) return "";

  const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
  const padding = base64.length % 4 === 0 ? "" : "=".repeat(4 - (base64.length % 4));
  const base64String = base64 + padding;

  if (typeof window !== "undefined" && window.atob) {
    return window.atob(base64String);
  }

  if (typeof Buffer !== "undefined") {
    return Buffer.from(base64String, "base64").toString("utf-8");
  }

  return "";
};

export const decodeTokenPayload = (token) => {
  try {
    if (!token?.split) return null;
    const base64Url = token.split(".")[1];
    if (!base64Url) return null;
    const jsonPayload = decodeBase64Url(base64Url);
    return jsonPayload ? JSON.parse(jsonPayload) : null;
  } catch (error) {
    return null;
  }
};

export const extractRoleFromToken = (token) => {
  const payload = decodeTokenPayload(token);
  return payload?.role || null;
};

export const isAdminRole = (role) => role === "admin" || role === "superadmin";

export const isAuthorizedToken = (token) => {
  const role = extractRoleFromToken(token);
  return isAdminRole(role);
};
